<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="samplingForm" :refresh-key="refreshKey" :show-expand="false" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                samplingForm: () => import('../forms/SamplingForm'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Product', value: 'productId', table: 'products', form: () => import('../forms/ProductForm') },
                    { text: 'Honey Type', value: 'honeyTypeId', table: 'honeyTypes', form: () => import('../forms/HoneyTypeForm') },
                    { text: 'Activity Grade', value: 'activityGrade' },
                    { text: 'For Client', value: 'forClient' },
                    { text: 'Is Blend', value: 'isBlend' },
                    { text: 'Has Passed Testing', value: 'hasPassedTesting' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    honeyTypes: [],
                    members: [],
                    products: [],
                    items: []
                },
                sorting: [
                    { column: "activityGrade", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "productId", direction: "ascending" },
                    { column: "honeyTypeId", direction: "ascending" },
                ],
                itemsField: 'samplings',
                editPageName: 'sampling',
                apiMethod: 'Samplings',
                claimName: 'Samplings',
                formTitle: 'Sampling',
                excelTitle: 'Samplings',
                hasEditPage: false,
            }
        },
    };
</script>
